<div class="image-container glass rounded-circle mb-3" [style]="pictureSize">
    <ng-container *ngIf="!imageUrl || imageUrl.length === 0">
        <i class="fas fa-user m-auto fa-3x"></i>
    </ng-container>
    <img [style]="pictureSize" class="rounded-circle" *ngIf="imageUrl && imageUrl.length !== 0" [src]="imageUrl | secure" alt="Profile picture">
</div>
